import { Dialog, DialogContent, DialogTitle, Typography } from '@material-ui/core'
import { ErrorConfig } from 'graphql/types'
import * as React from 'react'

export interface ErrorDialogProps {
    errorConfig?: ErrorConfig
    onClose?: () => void
}

const ErrorDialog = (props: ErrorDialogProps): JSX.Element => {
    const { errorConfig: ec, onClose } = props

    const handleClose = (_event: React.SyntheticEvent, reason: string): void => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            onClose?.()
        }
    }

    return (
        <div>
            {ec && (
                <Dialog aria-labelledby={'customized-dialog-title'} open={true} onClose={handleClose}>
                    <DialogTitle id={'customized-dialog-title'}>{ec.title}</DialogTitle>
                    <DialogContent style={{ padding: '24px' }} dividers>
                        <Typography>{ec.content}</Typography>
                        {ec.messages && <Typography>{ec.messages}</Typography>}
                    </DialogContent>
                </Dialog>
            )}
        </div>
    )
}

export default ErrorDialog
